import React from "react";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import bgSliders from "../../helpers/bgSliders";
import DjzFailPageDisplay from "./DjzFailPage.styled";
import "./DjzFailPage.scss";

const randomBg = bgSliders.getRandomBg();

function DjzFailPage({ t }) {
  return (
    <DjzFailPageDisplay className="" bgImg={randomBg}>
      <div className="formPage">
        <div className="formsLayout">
          <div className="header">
            <Link to="/">
              <div className="logo" />
            </Link>
          </div>
          <div className="center">
            <p className="message">
              <Trans>subscription_failed</Trans>
            </p>
            <Link to="/djz-signup" className="btn">
              <Trans>try_again</Trans>
            </Link>
            <Link to="/" className="btn-link">
              <Trans>back_home</Trans>
            </Link>
          </div>
        </div>
      </div>
    </DjzFailPageDisplay>
  );
}

export default withTranslation()(DjzFailPage);
